import { Component, OnInit, Renderer2, OnDestroy, ViewChild, HostListener, AfterViewInit, HostBinding } from '@angular/core';
import { UserTheme } from './_shared/app.globalVriables';
import { TranslateService } from '@ngx-translate/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Router, NavigationStart, NavigationEnd, NavigationCancel, NavigationError } from '@angular/router';
import { CommonService } from '@services/app.common.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ApplicationUpdateCheckerService } from '@services/service-worker-check-update';
import { AuthenticationService } from '@services/authentication.service';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { UserInfo } from './_shared/_models/common/userInfo';
import { StatusCode } from './_shared/_enums/Common';
import { first } from 'rxjs/operators';
import { DeviceIdentificationService } from '@services/device-identification.service';
import { DynamicScriptLoaderService } from '@services/dynamicScriptLoaderService';
import { Subscription } from 'rxjs';
import { AlertService } from '@services/alert.service';
import { TitleService } from '@services/title.service';
import { JTUserIdleService } from './_shared/userIdle/user-idle.service';
import { SlimLoadingBarService } from './_shared/_customComponent/ng2-slim-loading-bar';



@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    standalone: false
})

export class AppComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('ConfirmLogoutModal', { static: true }) confirmLogoutModal?: ModalDirective;
  @ViewChild('RefreshTokenFaildedModal', { static: true }) refreshTokenFaildedModal?: ModalDirective;


  public require: any;
  title = 'app';
  template = `<div class="loader-container">
    <div class="loader-logo">
      <div class="loader-circle"></div>
    </div>
  </div>`;
  // template: string = `<img class="imageContainer" src="assets/loading-image.gif" />`;
  cssUrlBootStrap? : SafeResourceUrl;
  cssUrlfontawesome? : SafeResourceUrl;
  cssUrljobtrain? : SafeResourceUrl;
  cssUrlApplicationForm? : SafeResourceUrl;
  cssUrlSpryTabbedPanels? : SafeResourceUrl;
  cssUrlCustom? : SafeResourceUrl;
  cssUrlCustomStyle? : SafeResourceUrl;
  cssUrlDatePicker? : SafeResourceUrl;
  cssUrlCustomce? : SafeResourceUrl;
  cssUrlIEStyles? : SafeResourceUrl;
  cssStyle? : SafeResourceUrl;
  cssSwitchery?: SafeResourceUrl;
  cssUrlCleanCustom?: SafeResourceUrl;
  public userInfo?: UserInfo;
  public StatusCode = StatusCode;
  public error:string = '';
  public isPassword:string = 'text';
  public timerCount:number = 0;
  public refreshTokenFailedtimerCount: number = 0;

  public modelShown = false;
  public innerWidth: number= 0;
  public refreshIntervalId: any;
  public refreshTokenInProgress: boolean = false;
  public keepAliveInprogress: boolean = false;
  public isIE11Browser: boolean = true;
  public failedTokeninterval:any;
  public isIdleTimeOutRegistered: boolean = false;
  public hideKeepWorkingButton: boolean = false;
  public KeepWorkingButtonText = "Messages.YesKeepWorking";
  public logOutButtonText ="Messages.NoLogout";

  @HostBinding('@.disabled')
  public animationsDisabled = false;

  subscription: Subscription = Subscription.EMPTY;;
  user = {
    userName: '',
    password: ''
  };
  private sub: any;
  constructor(
    private translate: TranslateService,
    public Loader: NgxSpinnerService,
    public sanitizer: DomSanitizer,
    private renderer: Renderer2,
    private router: Router,
    private common: CommonService,
    private slimLoader: SlimLoadingBarService, private sw: ApplicationUpdateCheckerService, private authService: AuthenticationService, private userIdle: JTUserIdleService, private deviceIdentificationService: DeviceIdentificationService, public dynamicScripts: DynamicScriptLoaderService, public titleService: TitleService
  ) {





    // check the service worker for updates
    // this.sw.checkForUpdates();
    this.renderer.removeClass(document.body, 'body-class');
    this.renderer.addClass(document.body, 'body-class-login');
    router.events.subscribe(event => {

      if (event instanceof NavigationStart) {

        this.common.animationState = 'hide';
        // Loader.show();
        this.slimLoader.start();
        this.common.RemoveLocalStorage('refreshTokenInProgress');
        // console.log("Navigation start");
      } else if (event instanceof NavigationEnd || event instanceof NavigationCancel || event instanceof NavigationError) {
        this.slimLoader.complete();
        this.common.RemoveLocalStorage('refreshTokenInProgress');
        setTimeout(() => {
          this.initCountDownTimer();
        }, 2000);

        setTimeout(() => {
          this.getScreenSize();
        }, 200);
      }
    }, (error: any) => {
      Loader.hide();
      // this.slimLoader.complete();
    });




  }

  ngOnDestroy(): any {
    this.common.RemoveLocalStorage('refreshTokenInProgress');
    if (this.sub) {
      this.sub.unsubscribe();
    }
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    if (this.refreshIntervalId) {
      clearInterval(this.refreshIntervalId);
      clearInterval(this.failedTokeninterval);
    }
  }

  ngOnInit() {

    this.common.loadTheme("");

    this.subscription = this.titleService.getMessage().subscribe(message => {
      if (message && message == 'refreshToken') {

        this.refreshToken(true);
      }
    });
    this.getTrustedUrl();
    jQuery(document).on('click', '.ngx-dropdown-button', function () {
      jQuery(this).closest('div.ngx-dropdown-container').find('input[name=\'search\']').focus();

    });



    
    const clientSetting = this.common.getClientSettings();
    this.animationsDisabled = clientSetting.AnimationsDisabled;

  //  var userLang = navigator.language.split('-')[0]; // use navigator lang if available
    let userLang = clientSetting.ApplicationLanguage;

    userLang = !this.common.isNullOrWhiteSpace(userLang) ? userLang : 'en';


    this.common.SetLocalStorage('lang', userLang);
    this.translate.setDefaultLang(userLang);
    this.translate.use(userLang)
      .subscribe(() => {
      }, err => {
        console.error(`Problem with '${userLang}' language initialization.'`);
      });

    this.common.RemoveLocalStorage('refreshTokenInProgress');
    this.refreshIntervalId = setInterval(() => {
      this.refreshToken();
    }, 60 * 1000);


  }
  ngAfterViewInit() {
    this.refreshToken();
  }

  isUserLoggedIn() {
    if (this.router.url.indexOf('/Login') == -1) {
      if (!this.authService.isUserLoggedIn()) {
        // this.openConfirmModal();
      } else {
        // this.closeConfirmModal();
      }
    }
  }
  getTrustedUrl() {
    this.cssUrlBootStrap = this.sanitizer.bypassSecurityTrustResourceUrl('assets/NewJT7/css/bootstrap.min.css');
    this.cssUrlfontawesome = this.sanitizer.bypassSecurityTrustResourceUrl('assets/NewJT7/css/font-awesome.css');
    this.cssUrlCustomStyle = this.sanitizer.bypassSecurityTrustResourceUrl('assets/NewJT7/css/custom_style.css');
    this.cssUrlCustom = this.sanitizer.bypassSecurityTrustResourceUrl('assets/NewJT7/css/custome.css');
    this.cssUrlDatePicker = this.sanitizer.bypassSecurityTrustResourceUrl('assets/NewJT7/css/datepicker.css');
    this.cssUrlCustomce = this.sanitizer.bypassSecurityTrustResourceUrl('assets/NewJT7/css/customce.css');
    this.cssUrlCleanCustom = this.sanitizer.bypassSecurityTrustResourceUrl('assets/NewJT7/css/cleanCustom.css');
    // this.cssStyle = this.sanitizer.bypassSecurityTrustResourceUrl('assets/NewJT7/css/style.css');
    this.cssSwitchery = this.sanitizer.bypassSecurityTrustResourceUrl('assets/NewJT7/JTForms/switchery-master/switchery.css');
    const browser = this.common.getBrowserInfo();
    if (browser.indexOf('Trident/') > -1 && browser.indexOf('rv:11') > -1) {
      this.isIE11Browser = true;
      this.cssUrlIEStyles = this.sanitizer.bypassSecurityTrustResourceUrl('assets/NewJT7/css/ie-style-only.css');
    } else {
      this.isIE11Browser = false;
    }


  }

  public openConfirmModal() {

    this.isPassword = 'password';
    this.userInfo = this.common.GetLoggedinUserInfo();
    this.confirmLogoutModal?.show();
  }
  public initCountDownTimer() {

    // if (!this.authService.isUserLoggedIn())
    //  return;

    this.userIdle.stopWatching();
    const settings = this.common.getSettings();
    const clientSetting = settings.ClientSetting;
    let idleTimeOut = 2100;
    if (clientSetting != null && clientSetting != '') {
      idleTimeOut = clientSetting.IdleTimeOut;
    }
    this.userIdle.setConfigValues({ idle: idleTimeOut, timeout: 300, ping: 300 });
    console.log('Moduel Regstration done startWatching:');
    this.userIdle.startWatching();
    this.modelShown = false;
    // Start watching when user idle is starting.
    this.userIdle.onTimerStart().subscribe(count => {
      if (!this.common.isNullOrWhiteSpace(count)) {
        const remainingTime = 300 - count;
        this.timerCount = remainingTime;
        // if (this.timerCount <= 0) {
        // this.common.logOut();
        // }

        if (this.authService.isUserLoggedIn()) {
          this.openConfirmModal();
        }
      }
    });

    // Start watch when time is up.
    this.userIdle.onTimeout().subscribe(() => {
      this.common.RedirectToLogin();
    });

    this.userIdle.ping$.subscribe(() => {
      // this.refreshToken()
    }
    );



  }

  public closeConfirmModal() {
    this.isPassword = 'text';
    this.confirmLogoutModal?.hide();
  }

  public logout() {
    if (this.refreshIntervalId) {
      clearInterval(this.refreshIntervalId);
    }
    // this.common.logOut();
    this.common.RedirectToLogin();
  }



  public keepWorking() {

    this.KeepWorkingButtonText = 'Messages.Processing';
    this.refreshToken(true, true);
    this.userIdle.resetTimer();
    this.confirmLogoutModal?.hide();

  }

  public ManuallTokenRefresh() {
    if (this.authService.isUserLoggedIn()) {

      this.KeepWorkingButtonText = "Messages.Processing";
      this.common.Loader.show();
      this.common.RemoveLocalStorage("refreshTokenInProgress");
      this.refreshToken(true)
    }
    else {
      this.hideKeepWorkingButton = true;
      this.logOutButtonText ="Messages.BackToLogin"

    }
  }



  login() {
    this.confirmLogoutModal?.hide();
    // var hideModal = function () {
    //   this.confirmLogoutModal.hide();
    // };
    // this.common.Loader.show();
    // var $this = this;
    // this.user.userName = this.userInfo.userName;
    // this.authService.login(this.user.userName, this.user.password, hideModal);
  }


  refreshToken(forceRefresh = false, closeModal = false) {

    const $this = this;

    if (!this.authService.isUserLoggedIn()) {
      return;
    }


    const currentDate = new Date();


    const lastRefreshTime = new Date(this.common.GetFromLocalStorage('lastTokenRefreshtime'));
    const difference = currentDate.getTime() - lastRefreshTime.getTime(); // This will give difference in milliseconds
    const resultInSeconds = Math.round(difference / 1000);

    // calculate remaining token time in seconds
    const tokenExpireDate = this.authService.GetTokenExpirationDate();
    let remainingTimeExpire = Math.round((tokenExpireDate.getTime() - currentDate.getTime()) / 1000);
    if (remainingTimeExpire <= 180) {
      if (this.refreshTokenFailedtimerCount == 0) {
        this.common.RemoveLocalStorage('refreshTokenInProgress');
        this.refreshTokenFailedtimerCount = remainingTimeExpire - 5;
        this.startRefreshTokenFailedTimer();
      }

      this.refreshTokenFaildedModal?.show();
    }



    const refreshTokenInProgressTime = new Date(this.common.GetFromLocalStorage('refreshTokenInProgress'));
    const remainingTime = Math.round((currentDate.getTime() - refreshTokenInProgressTime.getTime()) / 1000);
    if (remainingTime <= 10) {
      return;
    }


    if (resultInSeconds >= 300 || forceRefresh) {
      this.common.SetLocalStorage('refreshTokenInProgress', new Date());
      const lastToken = this.common.GetAccessToken();
      this.authService.refreshToken().pipe(first()).subscribe((res: any) => {
        this.refreshTokenInProgress = false;
        try {
          if (res.status == StatusCode.OK) {
      
            this.common.RemoveLocalStorage("refreshTokenInProgress");
            this.common.SetLocalStorage("lastTokenRefreshtime", new Date());
            this.common.SetAccessToken(res.resultData);
            if (closeModal) {
              this.modelShown = false;
              this.confirmLogoutModal?.hide();
              this.userIdle.resetTimer();

            }


            // manual token refersh code
            this.refreshTokenFaildedModal?.hide();
            this.common.Loader.hide();
            this.refreshTokenFailedtimerCount = 0;
            clearInterval(this.failedTokeninterval);

            this.KeepWorkingButtonText = 'Messages.YesKeepWorking';
            // this.common.PostData(this.common.ApiUrls.SystemUser.RevokeToken, null, false, lastToken).then(function (data) {
            // });
          } else {
            this.KeepWorkingButtonText = 'Messages.YesKeepWorking';
            this.common.RemoveLocalStorage('refreshTokenInProgress');
          }

        } catch (e) {
          this.KeepWorkingButtonText = 'Messages.YesKeepWorking';
          this.common.RemoveLocalStorage('refreshTokenInProgress');
        }
      }, error => {
        this.KeepWorkingButtonText = 'Messages.YesKeepWorking';
        this.common.RemoveLocalStorage('refreshTokenInProgress');
      });
    }
  }

  startRefreshTokenFailedTimer() {
    this.failedTokeninterval = setInterval(() => {
      if (this.refreshTokenFailedtimerCount > 0) {
        this.refreshTokenFailedtimerCount--;
        if (this.refreshTokenFailedtimerCount <= 0) {
          this.common.RedirectToLogin();
        }
      }
    }, 1000);
  }






  keepAlive() {

    return;
    const $this = this;
    // var token = this.common.GetAccessToken();
    // if (token == null || token == "") {
    //  var expiredToken = token = this.common.GetFromLocalStorage("expiredToken")
    //  if (expiredToken != null && expiredToken != "") {
    //    this.common.SetAccessToken(expiredToken);
    //  }
    // }
    if (this.keepAliveInprogress) {
      return;
    }
    const lastPingTime = new Date(this.common.GetFromLocalStorage('lastPingtime'));
    const currentDate = new Date();

    const difference = currentDate.getTime() - lastPingTime.getTime(); // This will give difference in milliseconds
    const resultInMinutes = Math.round(difference / 60000);
    if (resultInMinutes >= 10) {
      this.keepAliveInprogress = true;
      $this.common.SetLocalStorage('lastPingtime', new Date());
      this.common.GetData(this.common.ApiUrls.System.KeepAlive, false).then(function (data) {
        if (data.status == StatusCode.OK) {
          $this.common.SetLocalStorage('lastPingtime', new Date());
          $this.keepAliveInprogress = false;
        } else {
          $this.keepAliveInprogress = false;
        }
      });


    }
  }

  // @HostListener('window:resize', ['$event'])
  getScreenSize(event?:any) {
    this.deviceIdentificationService.setWidth(window.innerWidth);
    // this.innerWidth = window.innerWidth;
  }
}
